import { MenuItem, Stack, TextField } from "@mui/material";
import React, { useEffect, useState } from "react"
import { useParams } from "react-router";
import { useAppDispatch } from "../../../../../../app/hooks";
import { RuleDeleteCommand, RulePostCommand } from "../../../../../../services/contractService/commands";
import { contractApi, useContractsForCalculatorQuery, useFeeScheduleListFindQuery, useRuleDeleteMutation, useRuleSaveMutation } from "../../../../../../services/contractService/contract-api";
import { RuleCommands } from "./RuleCommands";

type ownProps = {
    ruleId:string;
    ruleString?:string;
    ruleDescription?:string;
}
function PercentOfFeeSchedule(props:ownProps){
    const {id} = useParams();
    const dispatch = useAppDispatch();
    const [rule,setRule] = useState({linkedContract:'',feeSchedule:'',rate:'0'})
    const [skip,setSkip] = useState(true);
    const medicareContracts = useContractsForCalculatorQuery("Medicare");
    const feeSchedules = useFeeScheduleListFindQuery(rule.linkedContract === '' ? '0' : rule.linkedContract)
    const [saveRule] = useRuleSaveMutation();
    const [deleteRule] = useRuleDeleteMutation();
    const save=()=>{
        let command = new RulePostCommand(id!,props.ruleId,'PercentOfFeeSchedule',0, JSON.stringify(rule),props.ruleDescription ?? '');
        saveRule(command).unwrap().then(()=>{dispatch(contractApi.util.invalidateTags(['ruleList']))});
    }
    const ruleDelete=()=>{deleteRule(new RuleDeleteCommand(props.ruleId))};
    useEffect(() => {
        if(props.ruleString !== ''){
            let r:{linkedContract:'',feeSchedule:'',rate:'0'} = JSON.parse(props.ruleString!);
            setRule(r);
        }},[props.ruleString, props.ruleId]
    )
    return <React.Fragment>
        <Stack direction='row' gap={1}>
            <TextField label='Contract' select size='small' sx={{width:'250px'}} InputLabelProps={{shrink:true}}
                value={rule.linkedContract} onChange={(e)=>{setRule({...rule,linkedContract:e.target.value});setSkip(false)}}> 
                <MenuItem value=''>Unknown</MenuItem>
                {medicareContracts.data?.map(i => (<MenuItem value={i.id}>{i.payer}</MenuItem>))}
            </TextField>
            <TextField label='Fee Schedule' select size='small' sx={{width:'450px'}} InputLabelProps={{shrink:true}}
                value={rule.feeSchedule} onChange={(e)=>setRule({...rule,feeSchedule:e.target.value})}>
                    <MenuItem value=''>Unknown</MenuItem>
                    {feeSchedules.data?.map(i => (<MenuItem value={i.id}>{i.description}</MenuItem>))}
            </TextField>
            <TextField label='Rate' size='small' InputLabelProps={{shrink:true}}
                value={rule.rate} onChange={(e)=>setRule({...rule, rate:e.target.value})}/>
        </Stack>
    <RuleCommands saveCommand={save} deleteCommand={ruleDelete} isNewRule={props.ruleId==='0'}/>
    </React.Fragment>
}

export {PercentOfFeeSchedule}